import {
  SupplementaryBoqStateTypes,
  SupplementaryBoqActionTypes,
} from "./SupplementaryBoq.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: SupplementaryBoqStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const SupplementaryBoqReducer = (
  state: SupplementaryBoqStateTypes = INITIAL_STATE,
  action: any
): SupplementaryBoqStateTypes => {
  switch (action.type) {
    case SupplementaryBoqActionTypes.FETCH_ALL_SUPPLEMENTARY_BOQ:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case SupplementaryBoqActionTypes.FETCH_ALL_SUPPLEMENTARY_BOQ_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SupplementaryBoqActionTypes.FETCH_ALL_SUPPLEMENTARY_BOQ_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SupplementaryBoqActionTypes.FETCH_ALL_SUPPLEMENTARY_BOQ_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case SupplementaryBoqActionTypes.FETCH_ONE_SUPPLEMENTARY_BOQ:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case SupplementaryBoqActionTypes.FETCH_ONE_SUPPLEMENTARY_BOQ_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case SupplementaryBoqActionTypes.FETCH_ONE_SUPPLEMENTARY_BOQ_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case SupplementaryBoqActionTypes.FETCH_ONE_SUPPLEMENTARY_BOQ_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default SupplementaryBoqReducer;
